<template>
  <el-dialog
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    v-model="visible"
    :title="initPwd ? t('header.setPassword') : t('header.changePassword')"
    width="500"
    @closed="handleClosed"
  >
    <el-form :model="form" label-width="100px" ref="ruleFormRef" :rules="rules">
      <el-form-item :label="t('header.oldPassword')" prop="old" v-if="!initPwd">
        <el-input v-model="form.old" :placeholder="t('header.enterOldPassword')" />
      </el-form-item>
      <el-form-item :label="initPwd ? t('header.setPassword') : t('header.newPassword')" prop="password">
        <el-input v-model="form.password" :placeholder="t('header.enterNewPassword')" />
      </el-form-item>
      <el-form-item :label="t('header.confirmPassword')" prop="repassword">
        <el-input v-model="form.repassword" :placeholder="t('header.enterConfirmPassword')" />
      </el-form-item>
    </el-form>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="visible = false">{{ t('common.cancel') }}</el-button>
        <el-button type="primary" @click="handleSubmit">
          {{ t('common.confirm') }}
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script setup lang="ts">
import { clearToken } from "@/utils/common"
import { changePwd } from "@/api/login"
import { ElMessage } from "element-plus"
import { useI18n } from "vue-i18n"

const { t } = useI18n()
const router = useRouter()

const visible = defineModel<boolean>("visible", { default: false })
const props = defineProps<{ initPwd: boolean }>()

const ruleFormRef = ref<any>(null)
const form = ref({
  old: "",
  password: "",
  repassword: "",
})

const rules = reactive({
  old: [
    { required: true, message: t('header.enterOldPassword'), trigger: 'blur' },
  ],
  password: [
    { required: true, message: t('header.enterNewPassword'), trigger: 'blur' },
  ],
  repassword: [
    { required: true, validator: (_rule: any, value: any, callback: any) => {
      if (value === '') {
        callback(new Error(t('header.enterConfirmPassword')))
      } else if (value !== form.value.password) {
        callback(new Error(t('header.passwordMismatch')))
      } else {
        callback()
      }
    }, trigger: 'blur' },
  ],
})

const logout = () => {
  clearToken()
  router.replace({ path: "/login" })
}

const handleSubmit = () => {
  if (!ruleFormRef.value) return
  ruleFormRef.value.validate((valid: boolean) => {
    if (valid) {
      changePwd({
        password: form.value.old,
        newPassword: form.value.password,
      }).then(() => {
        ElMessage.success(
          props.initPwd ? t('header.passwordSetSuccess') : t('header.passwordChangeSuccess')
        )
        visible.value = false
        logout()
      }).catch(() => {})
    }
  })
}

// Reset the form after the close transition so the next open starts clean.
const handleClosed = () => {
  form.value.old = ""
  form.value.password = ""
  form.value.repassword = ""
  ruleFormRef.value?.clearValidate?.()
}
</script>
